import type { FaireProductEntity } from "../../entity_types/product";

export const p_1vg90imkjt: FaireProductEntity = {
  token: "p_1vg90imkjt",
  type: "product",
  name: "Gold Layering Necklace, Celestial Necklace, Layered Jewelry",
  brandToken: "b_753b7wy8",
  brandName: "Laalee Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/1cfbeec00def2dbd51768dfac5a9a488e05c3cee97b7db781407f474f05db1be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce050f493100b35185bbbe993b68093bebdc0b1fd486a168a5206d5bce46b8dd.jpeg",
    "https://cdn.faire.com/fastly/7a01315a5a3380f03624cf058a5ade835a00862cd01bc3a1352d8c8dacdabf8d.jpeg",
    "https://cdn.faire.com/fastly/2df7cfaa78a7e69c7ea0ed2ae9ee3e89bb4bce7eda8be2588a77e947a181a05b.jpeg",
    "https://cdn.faire.com/fastly/a227b36623071cbbc8ece3bb21d59e3ca893238fadf8173ba1ff6f6cec10bab0.jpeg",
    "https://cdn.faire.com/fastly/0f97d17c0a2c0b09192fc932610c16eec6b6ceea8f2923f5301dc3387bec5446.jpeg",
    "https://cdn.faire.com/fastly/f7fa37b115658380db5425b03fde3c5af6247c2a3ca3a3e288b058dfb839ac8f.jpeg",
    "https://cdn.faire.com/fastly/22fb1876e79ee33ceffa2ed318e45f67acf61e31be3dc652d64a678666d15395.jpeg",
    "https://cdn.faire.com/fastly/bfcb334346f089e297efb419d9c5a92bb2e2d7db53d09f3e0c98123aed666a57.jpeg",
  ],
  priceDollars: 13,
  description:
    "Gorgeous layering necklaces!\n\nChoose one (or a few!) of your favorites to layer together. Chain, jumprings, and clasp are 14k gold filled. Pendants are 14k gold plated (over brass). No nickel. These are high quality necklaces that are made to last with care. :)\n\nThe flower necklace #1 has slightly changed! The flower in my hand in the included picture will be the new #1\n\nChoose necklace and length in drop down!",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:10.684Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
